import { QuestionIds } from './QuestionIds';

export const DEFAULT_ANSWERS: Record<string, string> = {
  [QuestionIds.Welcome]: 'sleep',
  [QuestionIds.SleepAndActivityExtraMotivation]: 'no',
  [QuestionIds.AboutYouRoutine]: 'some_routine',
  [QuestionIds.AboutYouGuided]: 'not_much',
};
